module.exports = __webpack_public_path__ + "static/media/Yanfei.494f7aa4.png";